module.exports = __webpack_public_path__ + "img/icon-plus-round2.412ed357.svg";